import type {
  BookableTransportIngredient,
  BookableTransportIngredientFilters,
} from '@apps/main/modules/recipe/ingredients/bookableTransportIngredient';

import { AvailabilityOrder } from '@libs/trip-planner-interfaces';
import { exhaustiveGuard } from '@libs/utils';

import {
  TRANSPORT_PORT_SEPARATOR,
  TRANSPORT_PROPS_SEPARATOR,
  TRANSPORT_ID_SEPARATOR,
  TRANSPORT_FILTERS_SEPARATOR,
  TRANSPORT_CARRIER_SEPARATOR,
  SUGGESTION_ORDER_PREFIX,
  SerializedAvailabilityOrder,
} from './constants';
import { rangeTimeSerializer, rangePriceSerializer } from './helpers';

export function serializePorts(
  ingredient: BookableTransportIngredient
): string {
  return `${ingredient.fromPort}${TRANSPORT_PORT_SEPARATOR}${ingredient.toPort}${TRANSPORT_PROPS_SEPARATOR}`;
}

export function serializeTransportIds(transportIds: string[] = []): string {
  return `${transportIds.join(
    TRANSPORT_ID_SEPARATOR
  )}${TRANSPORT_FILTERS_SEPARATOR}`;
}

export function serializeTransportFilters(
  filters: BookableTransportIngredientFilters
): string[] {
  const serializedFilters: string[] = [];

  serializedFilters.push(
    rangeTimeSerializer.serialize(filters.departureTimeFilters) || ''
  );
  serializedFilters.push(
    rangeTimeSerializer.serialize(filters.arrivalTimeFilters) || ''
  );

  serializedFilters.push(filters.maxDurationInHours?.toString() ?? '');

  serializedFilters.push(
    rangePriceSerializer.serialize(filters.priceFilters) || ''
  );

  serializedFilters.push(
    filters.carrierFilters.join(TRANSPORT_CARRIER_SEPARATOR)
  );

  return serializedFilters;
}

export function serializeAvailabilityOrder(
  transport: BookableTransportIngredient
): string {
  let serializedAvailabilityOrder: string;

  switch (transport.availabilityOrder) {
    case AvailabilityOrder.None:
      serializedAvailabilityOrder = SerializedAvailabilityOrder.None;
      break;

    case AvailabilityOrder.Cheapest:
      serializedAvailabilityOrder = SerializedAvailabilityOrder.Cheapest;
      break;

    case AvailabilityOrder.Popular:
      serializedAvailabilityOrder = SerializedAvailabilityOrder.Popular;
      break;

    default:
      exhaustiveGuard(
        transport.availabilityOrder,
        'Unhandled availability order serializer'
      );
  }

  return `${TRANSPORT_FILTERS_SEPARATOR}${SUGGESTION_ORDER_PREFIX}${serializedAvailabilityOrder}`;
}
